import { EventsOfTask } from 'pages/Tasks/types'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import routes from 'services/RoutesProvider/routes'
import { TASK_STATES } from '../../ContentLists/TaskList/constants'
import type { ResolveActionButtonsProps } from '../../task-details-action-buttons/types'
import { getCommentButton } from '../../task-details-action-buttons/utils/get-comment-button'
import { getVerifyButton } from './get-verify-button'

export const getFrontlineActionButtons = (props: ResolveActionButtonsProps): Action[] => {
  const { task, t, canSendComment, navigate } = props
  const { statusFe, favurUuid } = task

  if (statusFe === TASK_STATES.closed) return []

  return [
    ...(navigate
      ? [
          getVerifyButton({
            t,
            onClick: () => navigate(`${routes.securitySetup}?taskUuid=${favurUuid}`),
          }),
        ]
      : []),
    ...(canSendComment
      ? [getCommentButton({ ...props, taskEvent: EventsOfTask.secureConnectionSendCommentToManager })]
      : []),
  ]
}
